import { CSSObject } from "@emotion/react";

export const standardsContainerCss: CSSObject = {
  paddingInline: 0,
  marginBlock: 0,
};

export const bannerCss = {
  root: {
    "&": {
      borderRadius: "8px",
      margin: "1rem 1rem 0.5rem",
    },
  },
};
